export default () =>
  window.API_ENDPOINT.includes('sjmk.roadhouse.agency') && process.env.NODE_ENV === 'production';
